import * as React from 'react'
import PropTypes from 'prop-types'
import './image-card.css'


export default class ImageCard extends React.Component<any, any>{


    static PropTypes = {
        imageURL: PropTypes.string.required,
        title: PropTypes.string.required,
        url: PropTypes.string.required
    }


    render(){
        const {
            imageURL,
            title,
            url
        } = this.props;

        return (
            <div className="col-12 mt-4">
                <div className="d-flex align-items-center pick-card">
                    <div className="hidden-sm-down">
                        <a href={ url }>
                            <img src={imageURL} className="mr-md-4" height="150" width="150" />
                            <span id="cobrandingLogo">
                            </span>
                        </a>
                    </div>
                    <div className="ml-2">
                        <div className="top-icon hidden-md-up">
                            <a href={ url }>
                                <img src={imageURL} className="mr-md-4" height="100" width="100" />
                            </a>
                        </div>
                        <a href={ url }>
                            <h4>{ title }</h4>
                        </a>
                        { this.props.children }
                    </div>
                </div>
            </div>
        )
    }

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/image-card.tsx